import React, { useState, useEffect} from "react";
import { LoyaltyTwoTone } from "@material-ui/icons";
import axios from "axios";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';

// Components
import SalesOrderInfoTable from "./SalesOrderInfoTable";
import SalesAddItem from "./SalesAddItem";
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import {  useParams, useHistory } from "react-router-dom";
import { format } from "date-fns";


//number format plugin
import numeral from "numeral";

import PurchaseOrderInfoTable from "../../Purchases/PurchaseOrderInfoTable";
import PurchaseAddItem from "../../Purchases/PurchaseAddItem";
import PurchaseEditShipping from "../../Purchases/PurchaseEditShipping";
import LoadingModal from "../../../components/Modal/LoadingModal";
import MessageBox from "../../../components/MessageBox/MessageBox";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { NavLink } from "react-router-dom";

import Slide from '@material-ui/core/Slide';
import Preloader from "../../../components/Preloader/Preloader";

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #59b259",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#c1c3d8",
		display:"none"
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(89, 178, 89, 0.09)",
		padding: "1rem",
		border: "1.5px solid #59b259",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #59b259",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
	root: {
		'&$disabled': {
		  color: '#f2f2f2',
		},
	  },
	  disabled: {},
});

const SalesReturnInformation = () => {
	const { shippingId, warehouseId, idNo, selectedDate} = useParams();
	const [soDetails, setSoDetails] = useState([]);

	const [poTotal, setPoTotal] = useState(0);
	const [shipTotal, setShipTotal] = useState(0);
	const [notes, setNotes] = useState('');

	const [items, setItems] = useState([]); //data to display in SO table
	const [supplierItem, setSupplierItem] = useState(null); 
	const [showModal, setShowModal] = useState(false);
	const [btnDisabled, setBtnDisabled] = useState(true);
	const [advancepayment, setAdvancepayment] = useState('no');

    //Message Box
    const [showMsgBox, setShowMsgBox] = useState(false);
    const [msgBoxContent, setMsg] = useState("Empty");
    const [msgType, setMsgType] = useState("success");
    //Message Box EOF

	const ColorButton = withStyles(() => ({
		root: {
		  color: "#fff",
		  backgroundColor: "#4caf50",
		  '&:hover': {
			backgroundColor: "#fff",
			color: "#4caf50",
		  }
		},
	  }))(Button);
	
	// combine all payment details neeeded before saving final SO
	// {
    //     "payment_id":paymentId,
    //     "payment_amount": parseFloat(paymentAmount),
    //     "payment_ref":paymentReference
    // }
	let history = useHistory();
	const classes = useStyles();
	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	useEffect(() => { //
		data();
	}, []);

	
	const addItem = (item) => {
		let found = items.some(x => x.item_id === item.item_id);
		if(found){
			//if item is existing in itemArray, add the qty instead
			let newItems = items.map((it)=> {
				if(it.item_id === item.item_id){ //add
					it.qty += item.qty;
			  	}
			  return it;
			});
			setItems(newItems);
		}else{
			//add new unique item to array
			setItems([...items, 
				{
				item_id: item.item_id, 
				qty: item.qty,
				price: item.price, 
				uomDesc: item.uomDesc,
				item_name: item.itemname
				}
			]);
		}	
	}

	const deleteItem = (item_id) => {
		//console.log(item_id);
		let itemArray = items.filter(item => item.item_id !== item_id);
		setItems(itemArray);
	}

	//update PO total when items update
	useEffect(() => {
		let po_total = 0;
		items.forEach(item => po_total += (item.price*item.qty))
		setPoTotal(po_total);

		if(items.length > 0) {
			setBtnDisabled(false); // re-enable
		}else{
			setBtnDisabled(true); // re-enable	
		}
	}, [items]);

	const data = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'/sales_return_form', {
			params:{
				idno:idNo,
				jc_user_id_no:get_cookies('branchidno'),
				trandate:selectedDate,
				shipping:shippingId,
				warehouse:warehouseId,
				curcode: get_cookies('curcode'), 
			}
		}).then((res)=>{
			setSoDetails(res.data.data);
			setSupplierItem(res.data.data.items);
		}).catch((error)=>{
			//console.log(JSON.stringify(error));
			setShowMsgBox(true);
			// setMsg("Something went wrong: "+error.message);
			setMsg("ID No not found");
			setMsgType("warning");
			setTimeout(() => {
				setShowMsgBox(false);
				setBtnDisabled(false); // re-enable
			}, 2500)
		});


	}

	const save_sr = async () => {
		setBtnDisabled(true); // disable button to avoid multiple saves
		setShowModal(true);
		const formData = new FormData();
		formData.append("item_array", JSON.stringify(items));
		formData.append("jc_u_idno", get_cookies('branchidno'));
		formData.append("jc_uname", get_cookies('username'));
		formData.append("idno", idNo);
		formData.append("warehouse", warehouseId);
		formData.append("pricecat", soDetails.pricecat);
		formData.append("trandate", format(new Date(), "yyyy-MM-dd"));
		formData.append("shipping", shippingId);
		formData.append("shippingcharge", shipTotal);
		formData.append("notes", notes);
			//show 3rd ui, sales order payment
			await axios.post(process.env.REACT_APP_API_URL+'save_sales_return', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
					}
			}).then(function (res) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("Added new Sales Return");
				setMsgType("success");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
					history.push('/sales/sales-return');
				}, 2000)
		  	}).catch(function (error) {
				setShowModal(false); //hide loading/please wait modal 
				setShowMsgBox(true);
				setMsg("Something went wrong: "+error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500)
	  		});
	}

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<NavLink to={"/sales"}><h4 style={{color:"#339933"}}>Sales</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<NavLink to={"/sales/sales-order"}><h4 style={{color:"#339933"}}>Sales Order</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4 className="header-title">Sales Return</h4>
			</div>
				{supplierItem ? (<div className="page-container">
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0}>
							<Grid item xs={12}>
								<div className={classes.subTitle}>
									Sales Return Information
								</div>
								<div className={classes.title}>
									Sales Return Information
								</div>
							</Grid>
								<Grid item xs={12} lg={8}>
									<Grid container spacing={3} style={{justifyContent: "flex-end", marginTop: "1em"}}>
										<PurchaseEditShipping shipTotal={shipTotal} setShipTotal={setShipTotal}/>
										{/* <div style={{marginRight: "0.5em"}}></div> */}
										<PurchaseAddItem addItem={addItem} supplierItem={supplierItem}/>
									</Grid>
								</Grid>	
							</Grid>
					</div>
					<CardContent>
						<LoadingModal showModal={showModal}/>
						<Grid container spacing={1}>
							<Grid item xs={12} lg={12} xl={12}>
								<div className={classes.infoContainer}>
								<Grid container spacing={3}>
									<Grid item xs={4} className={classes.infoTitle}>
										Return By:
									</Grid>
									<Grid
										item
										xs={8}
										className={classes.infoContent}
									>
											{soDetails.return_by || ''}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={4} className={classes.infoTitle}>
										ID No:
									</Grid>
									<Grid
										item
										xs={8}
										className={classes.infoContent}
									>
										{soDetails.idno || ''}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={4} className={classes.infoTitle}>
										Date:
									</Grid>
									<Grid
										item
										xs={8}
										className={classes.infoContent}
									>
											{soDetails.delivery_date || ''}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={4} className={classes.infoTitle}>
										Location:
									</Grid>
									<Grid
										item
										xs={8}
										className={classes.infoContent}
									>
											{soDetails.location || ''}
									</Grid>
								</Grid>
								</div>	
							</Grid>
						</Grid>
						{/* <SalesOrderInfoTable /> */}
						<SalesOrderInfoTable items={items} setItems={setItems} deleteItem={deleteItem}/>
						<div className={classes.infoTotal}>
							<div className={classes.infoTotalContent}>
								<div className={classes.infoTotalItem}>
									<LocalShippingTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Shipping: "+ numeral(shipTotal).format('0,0.00')}		
								</div>
								<div className={classes.infoTotalItem}>
									<ShoppingBasketTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Sub-Total: "+ numeral(poTotal).format('0,0.00')}
								</div>
								<div className={classes.infoTotalItem}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Total: "+ numeral(shipTotal+poTotal).format('0,0.00')}
								</div>
							</div>
						</div>
						<TextField
							label="Notes"
							multiline
							rows={4}
							variant="outlined"
							className={classes.textarea}
							onChange={(e)=>{setNotes(e.target.value)}}
						/>
					</CardContent>
				</Card>
					<div className={classes.buttonContainer}>
						<ColorButton disabled={btnDisabled} onClick={save_sr} variant="contained" color="primary" classes={{
    			root: classes.root, 
        		disabled: classes.disabled}}>
							Proceed
						</ColorButton>
					</div>
				</div>
		) : (<Preloader />)}		
		</div>
	);
};

export default SalesReturnInformation;
